var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_275_997",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_275_997)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4637 1.75026C7.26237 1.77826 4.66683 4.38459 4.66683 7.58359C4.66683 10.7826 7.26237 13.3889 10.4637 13.4169H10.4842H10.5161H10.5366C13.738 13.3889 16.3335 10.7826 16.3335 7.58359C16.3335 4.38459 13.738 1.77826 10.5366 1.75026C10.525 1.74968 10.5118 1.75026 10.5002 1.75026H10.4637ZM20.4168 14.0003C16.8731 14.0003 14.0002 16.8732 14.0002 20.4169C14.0002 23.9607 16.8731 26.8336 20.4168 26.8336C23.9606 26.8336 26.8335 23.9607 26.8335 20.4169C26.8335 16.8732 23.9606 14.0003 20.4168 14.0003ZM3.85791 15.7503C2.66091 15.7503 1.6875 16.7912 1.6875 18.0711V18.9586C1.6875 20.8725 2.67648 22.5358 4.47314 23.6412C5.98456 24.5716 7.99917 25.0836 10.1458 25.0836C11.5248 25.0836 12.8385 24.8594 14.0093 24.4604C13.2684 23.289 12.8335 21.9056 12.8335 20.4169C12.8335 18.6553 13.4399 17.0377 14.4479 15.7503H3.85791ZM20.4168 15.7503C21.5427 15.7503 22.4585 16.6661 22.4585 17.7919V18.7079C22.9607 18.838 23.3335 19.2905 23.3335 19.8336V22.7503C23.3335 23.3948 22.8114 23.9169 22.1668 23.9169H18.6668C18.0222 23.9169 17.5002 23.3948 17.5002 22.7503V19.8336C17.5002 19.2905 17.8729 18.838 18.3752 18.7079V17.7919C18.3752 16.6661 19.291 15.7503 20.4168 15.7503ZM20.4168 16.9169C19.9344 16.9169 19.5418 17.3095 19.5418 17.7919V18.6669H21.2918V17.7919C21.2918 17.3095 20.8992 16.9169 20.4168 16.9169Z",
    fill: "#FF671D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLocked);
export default __webpack_public_path__ + "static/media/user-locked.baa692283fa6b57c0d9a82c807f729a4.svg";
export { ForwardRef as ReactComponent };